import React from 'react';
import { DataTable } from 'primereact/datatable';
import { TabView, TabPanel } from 'primereact/tabview';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import {InputText} from 'primereact/inputtext';

const Request = (props) => {
    const requestLeave = props.data.filter(_ => _.requestFrom === "My Request") || [];
    const pendingApproval = props.data.filter(_ => _.requestFrom === "PendingForMyApproval Request" || _.requestFrom === "PendingForMyApproval Request ") || [];
    const requestInvolved = props.data.filter(_ => _.requestFrom === "Request Involved") || [];
    const actionPending = (props.actionsPending !== undefined) ? props.actionsPending : [];

    const openRequestLeave = props.data.filter(_ => _.requestFrom === "My Request" && _.status !== "Closed"  && _.status !== "Rejected") || [];

    let totalNotificationCount = openRequestLeave.length + pendingApproval.length + actionPending.length;
    localStorage.setItem('totalNotificationCount', totalNotificationCount);

    const pendingTemplate = (rowData, column) => {
        return <div className="actionCenter">
            <Button onClick={() => props.requestRedirect(rowData,'Pending Request')} type="button" icon="pi pi-eye" className="p-button-secondary" disabled={props.approveRejectDisabled}></Button>          
        </div>;
    }

    const requestInvolvedTemplate = (rowData, column) => {
        return <div className="actionCenter">
            <Button onClick={() => props.requestRedirect(rowData,'Request Involved')} type="button" icon="pi pi-eye" className="p-button-secondary" ></Button>          
        </div>;
    }

    const requestTemplate = (rowData, column) => {
        return <div className="actionCenter">
            <Button onClick={() => props.requestRedirect(rowData,'Your Request')} type="button" icon="pi pi-eye" className="p-button-secondary" ></Button>          
        </div>;
    }

    const actionTemplate = (rowData, column) => {
        return <div className="actionCenter">
            <Button onClick={() => props.requestRedirect(rowData,'Action Request')} type="button" icon="pi pi-eye" className="p-button-secondary" ></Button>          
        </div>;
    }
    
    const headerY = (
        <div style={{'textAlign':'right'}}>
            <InputText type="search" onInput={props.onSearchChangeY} placeholder="Search..." />
        </div>
    )

    const headerP = (
        <div style={{'textAlign':'right'}}>
            <InputText type="search" onInput={props.onSearchChangeP} placeholder="Search..." />
        </div>
    )

    const headerA = (
        <div style={{'textAlign':'right'}}>
            <InputText type="search" onInput={props.onSearchChangeA} placeholder="Search..." />
        </div>
    )

    const headerR = (
        <div style={{'textAlign':'right'}}>
            <InputText type="search" onInput={props.onSearchChangeR} placeholder="Search..." />
        </div>
    )

    return (
        <TabView activeIndex={props.activeIndex} >
            <TabPanel header={"Your Request (" + requestLeave.length + ')'} >

                <DataTable
                    header={headerY}
                    globalFilter={props.globalFilterY}
                    value={requestLeave}
                    responsive
                    className="p-datatable-customers animated fadeIn"
                    rowHover
                    selectionMode="single"
                    selection={props.selectedCar}
                    paginator
                    rows={8}
                    emptyMessage="No lists found" >
                    <Column field="requestNum" sortable={true} header="Request No." style={{ width: '120px' }} />
                    <Column field="requesterName" header="Requester Name" sortable={true} style={{ width: '146px' }} />
                    <Column field="requestDate" sortable={true} header="Request Date"  style={{ width: '100px' }} />
                    <Column field="remark" header="Remarks" />
                    <Column field="pendingWith" sortable={true} header="Status" style={{ width: '130px' }} />
                    <Column field="fromDate" sortable={true} header="From Date"  style={{ width: '100px' }} />
                    <Column field="toDate" sortable={true} header="To Date"  style={{ width: '100px' }} />
                    <Column field="action" body={requestTemplate} header="Action"/>
                </DataTable>

            </TabPanel>
            <TabPanel header={"Pending Approval (" + pendingApproval.length + ')'}>
                <div className="p-col-12" style={{ display: 'flex' }}>
                    <Button style={{width: '110px', marginRight: '12px'}} label="Approve" icon="pi pi-save" className="p-button-success" onClick={() => props.handleApprove('approve')} disabled={props.approveRejectDisabled} />
                    <Button style={{width: '100px'}} label="Reject" icon="pi pi-trash" className="p-button-danger" onClick={() => props.handleApprove('reject')} disabled={props.approveRejectDisabled} />
                </div>
                <DataTable
                    header={headerP}
                    globalFilter={props.globalFilterP}
                    value={pendingApproval}
                    responsive
                    className="p-datatable-customers animated fadeIn"
                    rowHover
                    selection={props.selectedApproval}
                    onSelectionChange={props.onApprovalChange}
                    paginator
                    rows={8}
                    emptyMessage="No lists found"  >
                    <Column selectionMode="multiple" style={{ width: '3em' }} />
                    <Column field="requestNum" sortable={true} header="Request No." style={{ width: '120px' }} />
                    <Column field="requesterName" header="Requester Name" sortable={true} style={{ width: '146px' }} />
                    <Column field="requestDate" sortable={true} header="Request Date"  style={{ width: '100px' }} />
                    <Column field="remark" header="Remarks" />
                    <Column field="pendingWith" sortable={true} header="Status" style={{ width: '130px' }} />
                    <Column field="fromDate" sortable={true} header="From Date"  style={{ width: '100px' }} />
                    <Column field="toDate" sortable={true} header="To Date"  style={{ width: '100px' }} />
                    <Column field="action" body={pendingTemplate} header="Action"/>
                </DataTable>
            </TabPanel>
            <TabPanel header={"Action To Be Taken (" + actionPending.length + ')'}>

                <DataTable
                    header={headerA}
                    globalFilter={props.globalFilterA}
                    value={actionPending}
                    responsive
                    className="p-datatable-customers animated fadeIn"
                    rowHover
                    selectionMode="single"
                    selection={props.selectedCar}
                    paginator
                    rows={8}
                    emptyMessage="No lists found"  >
                    <Column field="requestNum" sortable={true} header="Request No." />
                    <Column field="requesterName" sortable={true} header="Requester Name." />
                    <Column field="actionnum" sortable={true} header="Action No." />
                    <Column field="keyworD_TEXT" sortable={true} header="Action Type" />
                    <Column field="createddate" sortable={true} header="Request Date" />
                    <Column field="actiondescription" sortable={true} header="Description" />
                    <Column field="status" sortable={true} header="Status" />
                    <Column field="action" body={actionTemplate} header="Action"/>
                </DataTable>
            </TabPanel>
            <TabPanel header={"Request Involved (" + requestInvolved.length + ')'}>

                <DataTable 
                    header={headerR}
                    globalFilter={props.globalFilterR}
                    value={requestInvolved}
                    responsive
                    className="p-datatable-customers animated fadeIn"
                    rowHover
                    selectionMode="single"
                    selection={props.selectedCar}
                    paginator
                    rows={8}
                    emptyMessage="No lists found"  >
                    <Column field="requestNum" sortable={true} header="Request No." style={{ width: '120px' }} />
                    <Column field="requesterName" header="Requester Name" sortable={true} style={{ width: '146px' }} />
                    <Column field="requestDate" sortable={true} header="Request Date"  style={{ width: '100px' }} />
                    <Column field="remark" header="Remarks" />
                    <Column field="pendingWith" sortable={true} header="Status" style={{ width: '130px' }} />
                    <Column field="fromDate" sortable={true} header="From Date"  style={{ width: '100px' }} />
                    <Column field="toDate" sortable={true} header="To Date"  style={{ width: '100px' }} />
                    <Column field="action" body={requestInvolvedTemplate} header="Action"/>
{/* 
                    <Column field="requestNum" sortable={true} header="Request No." />
                    <Column field="requesterName" sortable={true} header="Requester Name" style={{ width: '180px' }} />
                    <Column field="requestDate" sortable={true} header="Request Date" />
                    <Column field="remark" header="Remarks" />
                    <Column field="status" sortable={true} header="Status" />
                    <Column field="fromDate" sortable={true} header="From Date" />
                    <Column field="toDate" sortable={true} header="To Date" />
                    <Column field="action" body={requestInvolvedTemplate} header="Action"/> */}
                </DataTable>
            </TabPanel>
        </TabView>
    );
}

export default Request;